import * as Yup from "yup";
import {BaseInput} from "../../generated/graphql";

const {string, object} = Yup;

// @ts-ignore
export const BaseInputValidationSchema = object().shape<BaseInput>({
    id: string().required(),
});
